import { z } from "zod/v3";

export const defaultLayout = [
  [
    ["profiles", "summary", "experience", "education", "projects", "volunteer", "references"],
    ["skills", "interests", "certifications", "awards", "publications", "languages"],
  ],
];

// Schema
export const metadataSchema = z.object({
  template: z.string().default("flareon"),
  layout: z.array(z.array(z.array(z.string()))).default(defaultLayout), // pages -> columns -> sections
  css: z.object({
    value: z.string().default(".section {\n\toutline: 1px solid #000;\n\toutline-offset: 4px;\n}"),
    visible: z.boolean().default(false),
  }),
  page: z.object({
    margin: z.number().default(36),
    format: z.enum(["a4", "letter"]).default("a4"),
    options: z.object({
      breakLine: z.boolean().default(true),
      pageNumbers: z.boolean().default(true),
    }),
  }),
  theme: z.object({
    background: z.string().default("#ffffff"),
    text: z.string().default("#000000"),
    primary: z.string().default("#2563eb"),
  }),
  typography: z.object({
    font: z.object({
      family: z.string().default("Rubik"),
      subset: z.string().default("latin"),
      variants: z.array(z.string()).default(["regular"]),
      size: z.number().default(13.1),
    }),
    lineHeight: z.number().default(1.15),
    hideIcons: z
      .union([z.boolean(), z.enum(["none", "all", "except-header"])])
      .transform((val) => {
        if (typeof val === "boolean") {
          return val ? "all" : "none";
        }
        return val;
      })
      .default("none"),
    underlineLinks: z.boolean().default(true),
    headingSize: z.preprocess(
      (val) => val ?? "standard",
      z.enum(["standard", "compact"]).default("standard"),
    ),
  }),
  notes: z.string().default(""),
});

// Type
export type Metadata = z.infer<typeof metadataSchema>;

// Defaults
export const defaultMetadata: Metadata = {
  template: "flareon",
  layout: defaultLayout,
  css: {
    value: ".section {\n\toutline: 1px solid #000;\n\toutline-offset: 4px;\n}",
    visible: false,
  },
  page: {
    margin: 36,
    format: "a4",
    options: {
      breakLine: true,
      pageNumbers: true,
    },
  },
  theme: {
    background: "#ffffff",
    text: "#000000",
    primary: "#2563eb",
  },
  typography: {
    font: {
      family: "Rubik",
      subset: "latin",
      variants: ["regular"],
      size: 13.1,
    },
    lineHeight: 1.15,
    hideIcons: "none",
    underlineLinks: true,
    headingSize: "standard",
  },
  notes: "",
};
